// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Toggle Firebase at runtime through env in local dev apps.
const firebaseEnabled = import.meta.env.VITE_FIREBASE_ENABLED === 'true';
const hasFirebaseConfig =
  firebaseConfig.apiKey &&
  firebaseConfig.authDomain &&
  firebaseConfig.projectId &&
  firebaseConfig.appId;

let app = null;
let analytics = null;

if (firebaseEnabled && hasFirebaseConfig) {
  app = initializeApp(firebaseConfig);
  try {
    analytics = getAnalytics(app);
  } catch (err) {
    // In non-browser environment or if analytics fails, keep analytics null.
    console.warn('Firebase analytics disabled:', err);
    analytics = null;
  }
} else {
  if (!firebaseEnabled) {
    // console.info('Firebase is disabled via VITE_FIREBASE_ENABLED');
  } else {
    // console.info('Firebase config missing, skipping initialization.');
  }
}

/**
 * Tracks a custom event with Google Analytics.
 *
 * @param {string} eventName The name of the event to track.
 * @param {object} eventParams Parameters to associate with the event.
 */
export const trackEvent = (eventName, eventParams) => {
  if (!analytics) {
    return;
  }

  try {
    logEvent(analytics, eventName, eventParams);
  } catch (e) {
    console.warn('Firebase Analytics error:', e);
  }
};

export { analytics, app };
